/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let GoldCoinO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M454.7072 426.667008l-81.883136-81.883136c-11.108352-11.108352-11.108352-29.11744 0-40.225792 11.108352-11.108352 29.118464-11.108352 40.226816 0l99.959808 99.959808 99.959808-99.959808c11.108352-11.108352 29.118464-11.108352 40.226816 0 11.108352 11.108352 11.108352 29.11744 0 40.225792l-81.883136 81.883136h82.90816c15.709184 0 28.444672 12.734464 28.444672 28.443648 0 15.710208-12.735488 28.444672-28.444672 28.444672H540.444672v85.334016h113.77664c15.710208 0 28.445696 12.734464 28.445696 28.443648 0 15.710208-12.735488 28.444672-28.444672 28.444672H540.444672v113.777664C540.444672 755.264512 527.70816 768 512 768s-28.444672-12.735488-28.444672-28.444672v-113.77664h-113.77664c-15.710208 0-28.445696-12.735488-28.445696-28.445696 0-15.70816 12.735488-28.443648 28.444672-28.443648h113.777664v-85.334016h-113.77664c-15.710208 0-28.445696-12.734464-28.445696-28.444672 0-15.70816 12.735488-28.443648 28.444672-28.443648h84.929536zM512 910.222336c219.931648 0 398.222336-178.290688 398.222336-398.222336 0-219.931648-178.290688-398.222336-398.222336-398.222336-219.931648 0-398.222336 178.290688-398.222336 398.222336 0 219.931648 178.290688 398.222336 398.222336 398.222336z m0 56.88832C260.64896 967.110656 56.889344 763.35104 56.889344 512S260.64896 56.889344 512 56.889344 967.110656 260.64896 967.110656 512 763.35104 967.110656 512 967.110656z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

GoldCoinO.defaultProps = {
  size: 18,
};

GoldCoinO = React.memo ? React.memo(GoldCoinO) : GoldCoinO;

export default GoldCoinO;
